import React, { useEffect } from 'react';
import classNames from 'classnames';
import { PRODUCT_CATEGORY } from 'src/constants/product';

import './tab.scoped.scss';
import { useLocation } from 'react-router-dom';
import { getParseQueryString } from 'src/services/util';
import { KY_BIXBY_NAME, KY_KARAOKE_NAME, KY_PREFIX_KARAOKE, KY_PREFIX_BIXBY } from 'src/constants/ky';
import { useModal } from 'src/ModalContext';
import { useTranslation } from 'react-i18next';

type ReturnType = {
  tab: PRODUCT_CATEGORY;
  setTab: (tab: PRODUCT_CATEGORY) => void;
  TabComponent: JSX.Element;
};

export default function useTab(): ReturnType {
  const [tab, setTab] = React.useState<PRODUCT_CATEGORY>(PRODUCT_CATEGORY.KARAOKE);
  const location = useLocation();
  const qs = getParseQueryString(location.search);
  const { showModal } = useModal();
  const { t } = useTranslation();

  useEffect(() => {
    if (qs.tab) {
      // @TODO for not launching bixby
      if (qs.tab === PRODUCT_CATEGORY.BIXBY) {
        showModal({
          message: t('common/bixby_not_launch_message'),
          success: () => {
            history.back();
            return;
          },
        });
        return;
      }
      setTab(qs.tab as PRODUCT_CATEGORY);
    }
  }, []);

  return {
    tab,
    setTab,
    TabComponent: (
      <div className="text-brown-grey flex h-12">
        <div
          className={classNames('tab relative N_14_M w-2/4 flex justify-center items-center cursor-pointer', {
            active: tab === PRODUCT_CATEGORY.KARAOKE,
          })}
          onClick={() => {
            setTab(PRODUCT_CATEGORY.KARAOKE);
          }}
        >
          <div className="flex items-center">
            <div>{KY_PREFIX_KARAOKE}</div>
            <div className="division-bluey-purple mx-1.5 opacity-20"></div>
            <div>{KY_KARAOKE_NAME}</div>
          </div>
        </div>
        <div
          className={classNames('tab relative N_14_M w-2/4 flex justify-center items-center cursor-pointer', {
            active: tab === PRODUCT_CATEGORY.BIXBY,
          })}
          onClick={() => {
            // @TODO for not launching bixby
            showModal({
              message: t('common/bixby_not_launch_message'),
              success: () => {
                return;
              },
            });
            // setTab(PRODUCT_CATEGORY.BIXBY);
          }}
        >
          <div className="flex items-center">
            <div>{KY_PREFIX_BIXBY}</div>
            <div className="division-bluey-purple mx-1.5 opacity-20"></div>
            <div>{KY_BIXBY_NAME}</div>
          </div>
        </div>
      </div>
    ),
  };
}
